module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-container",
    attrs: {
      "id": _vm.eleId
    }
  }, [_c('div', {
    staticClass: "scroller"
  }, [_c('div', {
    staticClass: "pulldown",
    class: [_vm.pulldownChangeStyle, {
      'hide': !_vm.displaypullDownDiv
    }],
    style: ({
      'margin-top': '-' + _vm.pullDownDiff + 'px'
    })
  }, [_c('div', {
    staticClass: "pulldown-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "pulldown-label"
  }, [_vm._v(_vm._s(_vm.pullDownTip))])]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "pullup",
    class: [_vm.pullupChangeStyle, {
      'hide': !_vm.displaypullUpDiv
    }]
  }, [_c('div', {
    staticClass: "pullup-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "pullup-label"
  }, [_vm._v(_vm._s(_vm.pullUpTip))])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-5b49628f!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/pull-to-refresh/index.vue
// module id = 79
// module chunks = 2